import { render, staticRenderFns } from "./MainImage.vue?vue&type=template&id=6230b6e9&scoped=true"
import script from "./MainImage.vue?vue&type=script&lang=ts"
export * from "./MainImage.vue?vue&type=script&lang=ts"
import style0 from "./MainImage.vue?vue&type=style&index=0&id=6230b6e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6230b6e9",
  null
  
)

export default component.exports